import {
  faMicrophone,
  faMicrophoneSlash,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface LargeMicVisualizerProps {
  isActive: boolean;
}

export const LargeMicVisualizer = ({ isActive }: LargeMicVisualizerProps) => {
  return (
    <div className="vai-flex vai-items-center vai-gap-4 vai-p-6 vai-bg-white">
      {/* Microphone Icon */}
      <div className="vai-relative vai-flex-shrink-0">
        {isActive ? (
          // Connected/Active state - Green circles with microphone
          <div className="vai-relative vai-w-32 vai-h-32 vai-flex vai-items-center vai-justify-center">
            {/* Outer ring - light mint green */}
            <div
              className="vai-absolute vai-w-28 vai-h-28 vai-rounded-full vai-bg-green-300 vai-animate-pulse"
              style={{ animationDuration: '1.5s' }}
            ></div>
            {/* Middle ring - medium mint green */}
            <div
              className="vai-absolute vai-w-24 vai-h-24 vai-rounded-full vai-bg-green-400 vai-animate-pulse"
              style={{
                animationDuration: '1.5s',
                animationDelay: '0.3s',
              }}
            ></div>
            {/* Inner circle - dark teal green */}
            <div className="vai-relative vai-w-20 vai-h-20 vai-rounded-full vai-bg-green-700 vai-flex vai-items-center vai-justify-center vai-z-10">
              <FontAwesomeIcon
                icon={faMicrophone}
                className="vai-text-white vai-text-3xl"
              />
            </div>
          </div>
        ) : (
          // Disconnected/Muted state - Red circles with muted microphone
          <div className="vai-relative vai-w-32 vai-h-32 vai-flex vai-items-center vai-justify-center">
            <div className="vai-relative vai-w-20 vai-h-20 vai-rounded-full vai-bg-red-700 vai-flex vai-items-center vai-justify-center vai-z-10">
              <FontAwesomeIcon
                icon={faMicrophoneSlash}
                className="vai-text-white vai-text-3xl"
              />
            </div>
          </div>
        )}
      </div>

      {/* Status Text */}
      <div className="vai-flex vai-flex-col vai-gap-1">
        {isActive ? (
          <>
            <p className="vai-font-bold vai-text-lg vai-text-gray-900">
              Microphone connected.
            </p>
            <p className="vai-text-sm vai-text-gray-600">Ready to record!</p>
          </>
        ) : (
          <>
            <p className="vai-font-bold vai-text-lg vai-text-gray-900">
              No active microphone found.
            </p>
            <p className="vai-text-sm vai-text-gray-600">
              Say something to activate the mic. If it&apos;s not responding,
              choose another mic.
            </p>
          </>
        )}
      </div>
    </div>
  );
};
